module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/previous-edition-mask-06c59e4caacb4dd15823e7e542cd4a39.png";